@if (entry.base?.display) {
  <form
    [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <div>{{entry?.base?.text}}</div>
    <mat-form-field appearance="outline">
      <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
      <mat-select
        [formControlName]="entry?.formControlAttributes?.formControlName"
        [id]="entry?.formControlAttributes?.formControlName"
        [aria-label]="entry?.formControlAttributes?.label"
        >
        @for (option of entry?.selectAttributes?.optionAttributes; track option) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-select>
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>
  </form>
}
